import $ from 'jquery';
import { createPopper } from '@popperjs/core';

export function init() {
    const $popperButtons = $('.js-popper');
    $popperButtons.each(function() {
        createPopper(this, this.nextElementSibling, {
            placement: 'auto'
        });

        const $this = $(this);
        $this.on('click', function() {
            $this.next().toggleClass('is-visible');
        });
    });
}

export default {
    init
};
